
import { OffCanvas, OffCanvasMenu, OffCanvasBody } from "react-offcanvas";

import Avatar from "../../Components/Avatar"
import UserOffCanvasMenuMain from "./UserOffCanvasMenuMain";
import UserOffCanvasMenuUser from "./UserOffCanvasMenuUser";
import {toggleOffCanvasIsActive} from "../../../Features/Misc/offCanvasSlice";
import {useDispatch,useSelector} from "react-redux";

export default function UserOffCanvas(props) {

    const {customHeight, customWidth, customMinWidth} = props;

    const height = (customHeight ? customHeight : " h-14 " )
    const width = (customWidth ? customWidth : " w-14 " )
    const minWidth = (customMinWidth ? customMinWidth : " min-w-14 " )


    //user controls
    const userControls = [
        {title: "My Account", icon: "ri-account-circle-line" },
        {title: "Settings", icon: "ri-settings-3-line" },
    ]


    const dispatch = useDispatch()
    const {offCanvasIsActive} = useSelector((state) => state.offCanvas)


    const handleClick = () => {
        dispatch(toggleOffCanvasIsActive())
    }





        return (
            <OffCanvas
                transitionDuration={230}
                effect={"overlay"}
                isMenuOpened={offCanvasIsActive}
                position={"right"}
                className={`w-64`}
            >
                <OffCanvasBody>
                    <div onClick={() => handleClick()}>
                        <Avatar
                            height={height}
                            width={width}
                            extraStyles={minWidth + " cursor-pointer "}
                            type={`user`}
                        />
                    </div>
                </OffCanvasBody>

                <OffCanvasMenu className={`z-50 grid grid-cols-12 grid-rows-12 bg-pink-dashboard ${offCanvasIsActive ? "w-full h-full" : "w-0 h-full"}` }>

                    <UserOffCanvasMenuMain func={handleClick} />
                    <UserOffCanvasMenuUser userControls={userControls} />
                </OffCanvasMenu>

            </OffCanvas>
        );

}
